<template>
    <div class="container" >
        <div class="nav_bar">
            <img src="~img/logo.svg">
        </div>
        <div class="system_name">
            <img src="~img/system_name.png">
        </div>
        <div class="login_div">
        <el-form :model="loginForm"  ref="loginForm" class="login_form" >
            <el-form-item >
                <label class="el-form-item__label" style="width: 100px;" prop="account">用户名</label>
                <el-input v-model="loginForm.account" auto-complete="off" style="width:70%;"></el-input>
            </el-form-item>
            <el-form-item >
                <label class="el-form-item__label" style="width: 100px;" prop="password">密&nbsp&nbsp&nbsp&nbsp码</label>
                <el-input type="password" v-model="loginForm.password" auto-complete="off" style="width:70%;"></el-input>
            </el-form-item>
            <el-form-item >
                <label class="el-form-item__label" style="width: 100px;" prop="verificationCode">验证码</label>
                <el-input  auto-complete="off" v-model="loginForm.verificationCode" style="width:45%;" @keyup.enter.native="handleLogin"></el-input>
                <div style="display: inline-block;">
                <input type="button"  class="verificationCode"  @click="createCode"  v-model="checkCode"/></div>
            </el-form-item>
            <el-button type="primary" class="submit_login_button" @click.native.prevent="handleLogin" :loading="logining">登录</el-button>
            <el-button type="primary" class="submit_common_button" @click.native.prevent="handleForgetPwd" >忘记密码</el-button>
            <el-button type="primary" class="submit_common_button" style="margin-left:2%;" @click.native.prevent="handleContactAdmin" >联系管理员</el-button>
            <div style="padding-top: 15px;padding-left: 100px;"><el-checkbox v-model="agreed"> <a href="#" style="color: white;" @click="showPrivacyAgreemenDialog">登录视为已同意平台用户协议隐私政策</a></el-checkbox></div>
        </el-form>
        </div>
        <el-dialog title="忘记密码" v-model="forgetPwdDialogVisible" @close="cancelForgetPwdFormAddSubmit">
                <el-form :model="forgetPwdForm" :rules="forgetPwdFormRules" ref="forgetPwdForm">
                    <span style="margin-left: 52px;">请输入用户邮箱，密码重置链接将自动发送至您的邮箱。 </span>
                    <el-form-item label="邮箱" prop="email" style="margin-top: 22px;width: 500px;" label-width="100px">
                        <el-input  v-model="forgetPwdForm.email" auto-complete="off" ></el-input>
                    </el-form-item>
                </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="cancelForgetPwdFormAddSubmit">取 消</el-button>
                <el-button v-bind:disabled="addSubmitButtonDisabled" type="primary" @click="forgetPwdFormOnSubmit">确 定</el-button>
              </div>
        </el-dialog>
        <el-dialog title="管理员" v-model="contactDialogVisible" @close="cancelContactDialog">
                <span >管理员邮箱为：cc.assistant@ap.jll.com </span>
                <button type="button"
            v-clipboard:copy="adminEmail"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">点击复制</button>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelContactDialog">关闭</el-button>
              </div>
        </el-dialog>
        <el-dialog title="用户隐私协议确认" v-model="acceptPrivacyAgreementDialogVisible" @close="cancelAcceptPrivacyAgreementDialog">
                 <span >我已阅读并同意用户协议和隐私政策 </span>
               <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAcceptPrivacyAgreementDialog">取 消</el-button>
                <el-button v-bind:disabled="acceptPrivacyAgreementButtonDisabled" type="primary" @click="acceptPrivacyAgreementOnSubmit">确 定</el-button>
              </div>
        </el-dialog>
        <el-dialog title="请输入邮箱验证码" v-model="verifyEmailDialogVisible" @close="cancelVerifyEmailDialog">
                <el-form :model="verifyEmailForm" :rules="verifyEmailFormRules" ref="verifyEmailForm">
                    <span style="margin-left: 52px;">由于安全性相关考虑，需要进行身份验证才能进行登录已发送一封验证码邮件到您的邮箱地址 </span>
                    <el-form-item label="" prop="verifyCode" style="margin-top: 22px;width: 500px;" label-width="100px">
                        <el-input placeholder="请输入邮箱内的验证码" v-model="verifyEmailForm.verifyCode" auto-complete="off" ></el-input>
                    </el-form-item>
                </el-form>
              <div slot="footer" class="dialog-footer">
                   <el-button v-bind:disabled="verifyEmailButtonDisabled" type="primary" @click="verifyEmailOnSubmit">确 定</el-button>
              </div>
        </el-dialog>

        <el-dialog title="JLL法律声明及隐私权政策" v-model="privacyAgreementContentDialogVisible" @close="cancelPrivacyAgreementContentDialog">
                  <div class="agreement-describe"><span>更新时间:{{agreementModifyTimeStr}} </span></div>
              <div style="color: #000000;" class="ql-editor"  v-html="privacyAgreementContent"></div> 
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelPrivacyAgreementContentDialog">关闭</el-button>
              </div>
        </el-dialog>
    </div>
</template>
<script>
    import api from '@/api';
    import tools from '@/util/tools';
    import Vue from 'vue'
    import global from '@/config/global_config'
    import 'quill/dist/quill.core.css'
    // require('ssl-root-cas').inject();

	export default {
        data() {
			return {
                checkCode:'',
                logining: false,
                loginForm: {
                    account: '',
                    password: '',
                    verificationCode:''
                },
                forgetPwdDialogVisible:false,
				contactDialogVisible:false,
                forgetPwdForm: {
                    email:''
                },
                forgetPwdFormRules: {
					email: [
						{ required: true, message: '邮箱不能为空', trigger: 'blur' },
						{ pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ ,message: '邮件格式不合法',trigger: 'blur'},
						{ min: 1, max: 80, message: '输入长度在1到80个字符之间',trigger: 'blur'}
					]
                },
                addSubmitButtonDisabled:false,
                adminEmail:'cc.assistant@ap.jll.com',
                privacyAgreementContentDialogVisible:false,
                privacyAgreementContent:'',
                privacyAgreementVersion:'',
                agreementModifyTimeStr:'',
                acceptPrivacyAgreementDialogVisible:false,
                acceptPrivacyAgreementButtonDisabled:false,
                verifyEmailDialogVisible:false,
                acceptPrivacyAgreementRequired:false,
                verifyEmailRequired:false,
                verifyEmailForm: {
                    email:''
                },
                verifyEmailFormRules: {
					verifyCode: [
						{ required: true, message: '验证码不能为空', trigger: 'blur' },
					]
                },
                verifyEmailButtonDisabled:false,
                agreed: false
            }   
        },
        methods: {
            handleForgetPwd(ev) {
                this.forgetPwdDialogVisible = true;
            },
            cancelForgetPwdFormAddSubmit(){
				this.forgetPwdDialogVisible = false
				this.$refs.forgetPwdForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
            },
             forgetPwdFormOnSubmit(){
                 this.$refs.forgetPwdForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = this.forgetPwdForm;
						this.listLoading = true;
						let self = this;
						api.account_forgetPwd_request(param).then((res) => {
							this.addSubmitButtonDisabled=false;
							this.listLoading = false;
							this.forgetPwdDialogVisible = false;
							this.$refs.forgetPwdForm.resetFields();
							tools.success(this,"提交成功");
						}).catch(function (e) {
							tools.error(new Vue(),e.message);
							self.forgetPwdDialogVisible=false;
						});
						this.listLoading = false;
					}
				})
            },
            handleContactAdmin(ev) {
                this.contactDialogVisible = true;
            },
            onCopy: function (e) {
                tools.success(this,"复制成功");
                this.contactDialogVisible = false;
            },
            onError: function (e) {        
                tools.error(new Vue(),'复制失败，请重试');
            },
            cancelContactDialog(){
                this.contactDialogVisible = false;
            },
            handleLogin(ev) {
                if(!this.agreed){
                    tools.error(this,'请先同意用户隐私协议');
                    return;
                }
                if(!tools.trim(this.loginForm.account)){
                    tools.error(this,'账号不能为空');
                    return;
                }
                if(!tools.trim(this.loginForm.password)){
                    tools.error(this,'密码不能为空');
                    return;
                }
                if(!tools.trim(this.loginForm.verificationCode)){
                    tools.error(this,'验证码不能为空');
                    return;
                }
                if(this.loginForm.verificationCode.toLowerCase() != this.checkCode.toLowerCase()){
                    tools.error(this,'验证码不正确');
                    this.createCode();
                    return;
                }
                var _this = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        var loginParams = { account: this.loginForm.account, password: this.loginForm.password };
                        api.account_login_request(loginParams).then(
                            res => {
                                this.logining = false;
                                sessionStorage.setItem('user', JSON.stringify(res.data));
                                if(!tools.strIsEmpty(res.data.upComingExpirePw)){
                                    sessionStorage.setItem('upComingExpirePw', res.data.upComingExpirePw);
                                }
                                if(!tools.strIsEmpty(res.data.upComingExpireProject)){
                                    let upComingExpireProject='';
                                    res.data.upComingExpireProject.forEach(one => {
                                        upComingExpireProject +=  one+';';
                                    });
                                    if(!tools.strIsEmpty(upComingExpireProject)){
                                        sessionStorage.setItem('upComingExpireProject', upComingExpireProject);
                                    }
                                }
                                sessionStorage.removeItem('localRoutes');
                                let globalPermissionNodeList = global.getInitialPermissionNodeList();
                                if(res.data.menuList){
                                    let dynamicRouter = [];
                                    // if(res.data.roleIdentity == "level-untrue"){
                                    //     temp = {path: '/',component:(resolve) => require(['@/pages/Home.vue'], resolve),name:"历史数据",iconCls:global.routerIconMap["historyData"],children:[
                                    //         {path:'/'+element.path,component:global.routerPathMap["historyAlarmList"],name:"列表数据"},
                                    //         {path:'/'+element.path,component:global.routerPathMap["historyAlarmCharts"],name:"报表数据"}
                                    //     ]}
                                    //     this.$router.options.routes.push(temp);
                                    //     dynamicRouter.push(temp);
                                    // }
                                    // else{
                                        res.data.menuList.forEach(one => {
                                            let temp;
                                            if(one.menuType == 0){
                                                if(one.parentId == 0){
                                                    if(one.path != 'currentAlarm'){
                                                        temp = {path: '/',component:(resolve) => require(['@/pages/Home.vue'], resolve),name:one.name,iconCls:global.routerIconMap[one.path],children:[]}
                                                        res.data.menuList.forEach(element => {
                                                            if(element.parentId == one.id){
                                                                temp.children.push({path:'/'+element.path,component:global.routerPathMap[element.path],name:element.name}); 
                                                            }
                                                        });
                                                        this.$router.options.routes.push(temp);
                                                        dynamicRouter.push(temp);
                                                    }
                                                }
                                            }
                                            else if(one.menuType == 1){
                                                if(globalPermissionNodeList.hasOwnProperty(one.code)){
                                                    globalPermissionNodeList[one.code].hasEntitle = 1;
                                                }
                                            }
                                        });
                                    //}
                                    sessionStorage.setItem('globalPermissionNodeList', JSON.stringify(globalPermissionNodeList));
                                    sessionStorage.setItem('localRoutes', JSON.stringify(dynamicRouter));
                                    this.$router.addRoutes(dynamicRouter);
                                 }
                                
                                //是否需要同意最新的隐私协议
                                 if(res.data.acceptPrivacyAgreementRequired){
                                    this.acceptPrivacyAgreementRequired = res.data.acceptPrivacyAgreementRequired;
                                    sessionStorage.setItem('acceptPrivacyAgreementRequired',this.acceptPrivacyAgreementRequired);
                                 }

                                 //是否需要验证邮箱
                                 if(res.data.verifyEmailRequired){
                                    this.verifyEmailRequired = res.data.verifyEmailRequired;
                                    sessionStorage.setItem('verifyEmailRequired', this.verifyEmailRequired);
                                 }
                                 if(this.acceptPrivacyAgreementRequired){
                                    this.acceptPrivacyAgreementDialogVisible = true;
                                    this.getNewestPrivacyAgreement();
                                    return;
                                 }
                                 if(this.verifyEmailRequired){
                                    this.verifyEmailDialogVisible = true;
                                    return;
                                 }

                                tools.success(this,'登录成功');
                                this.$router.push('/currentAlarm');
                            }).catch(function (e) {
                                console.log(e);
                                tools.error(new Vue(),e.message);
                            });
                    }
                    this.logining = false;
                });
            },
            createCode(){
                let code = "";    
                var codeLength = 4;
                var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',   
                'S','T','U','V','W','X','Y','Z');  
                for(var i = 0; i < codeLength; i++) {
                    var index = Math.floor(Math.random()*36);   
                    code += random[index];  
                }   
                this.checkCode = code;
            },
            cancelPrivacyAgreementContentDialog(){
                this.privacyAgreementContentDialogVisible = false;
            },

            getNewestPrivacyAgreement(){
				let param = {};
                let self = this; 
				api.acquireData_searchNewestAgreement_request(param).then((res) => {
					if(res.data){
						//this.privacyAgreementContent = '<div id="text-dom-UGCdOHukUSfMhv5z2QecOQ" class="text"><p class="listRTL listLTR" style="margin-bottom: 5px;line-height:17px;"><span style="color: rgb(170,170,170);font-size: 12px;font-family: SourceHanSansSC;font-weight: 700;line-height: 17px;">提示条款</span></p><p class="listRTL listLTR" style="margin-bottom: 5px;line-height:17px;"><span style="color: rgb(170,170,170);font-size: 12px;font-family: SourceHanSansSC;font-weight: 700;line-height: 17px;">欢迎您使用的产品及/或服务！我们深知用户信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于确保用户信息及隐私的安全性。基于此，计算有限公司（以下或简称“我们”）特制定本《法律声明和隐私政策》（以下或简称“本政策”），帮助您充分了解在您使用我们产品及/或服务的过程中，我们会如何收集、使用、共享、存储和保护您的用户信息以及您可以如何管理您的用户信息，以便您更好地作出适当的选择。</span></p><p class="listRTL listLTR" style="margin-bottom: 5px;line-height:17px;"><span style="color: rgb(170,170,170);font-size: 12px;font-family: SourceHanSansSC;font-weight: 700;line-height: 17px;">在您开始使用我们的产品及/或服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体/粗体下划线标识的条款，确保您充分理解和同意之后再开始使用。除本政策外，在特定场景下，我们还会通过即时告知（含弹窗、页面提示等）、功能更新说明等方式，向您说明对应的信息收集目的、范围及使用方式，这些即时告知及功能更新说明等构成本政策的一部分，并与本政策具有同等效力。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。</span></p><p style="line-height:17px;"><span style="color: rgb(170,170,170);font-size: 12px;font-family: SourceHanSansSC;font-weight: 700;line-height: 17px;">您同意本政策表示您已了解我们提供的产品及/或服务，以及相应产品及/或服务功能运行所需的必要用户信息（请特别注意，本政策所述用户信息可能包含个人信息及/或敏感个人信息，具体请见“附录：相关定义”，以下不再赘述），并给予相应的收集使用授权。</span></p></div>';
                        this.privacyAgreementContent = res.data.content;
                        this.privacyAgreementVersion = res.data.currentVersion;
                        this.agreementModifyTimeStr = res.data.modifyTimeStr;
					}
				}).catch(function (e) {
					console.log(e);
                    self.privacyAgreementContentDialogVisible = false;
                    tools.error(new Vue(),e.message);
				});
			},

            acceptPrivacyAgreement(){
                if(!tools.trim(this.privacyAgreementVersion)){
                    tools.error(this,'协议版本号不能为空');
                    return;
                }
				let param = {version:this.privacyAgreementVersion};
				api.acquireData_acceptAgreement_request(param).then((res) => {
					if(res.data){
						tools.success(this,'同意协议成功');
					}
                    else{
                        tools.error(this,'同意协议失败');
                    }
				}).catch(function (e) {
					console.log(e);
                    tools.error(new Vue(),e.message);
				});
			},
            showPrivacyAgreemenDialog(){
                this.getNewestPrivacyAgreement();
                this.privacyAgreementContentDialogVisible = true;
            },
            cancelAcceptPrivacyAgreementDialog(){
                this.acceptPrivacyAgreementDialogVisible = false;
                if(this.acceptPrivacyAgreementButtonDisabled)this.acceptPrivacyAgreementButtonDisabled = false;
            },
            acceptPrivacyAgreementOnSubmit(){
                if(!tools.trim(this.privacyAgreementVersion)){
                    tools.error(this,'协议版本号不能为空');
                    return;
                }
                this.listLoading = true;
				let self = this;    
                this.acceptPrivacyAgreementButtonDisabled = true;
				let param = {version:this.privacyAgreementVersion};
				api.acquireData_acceptAgreement_request(param).then((res) => {
                    this.acceptPrivacyAgreementButtonDisabled = false;
					if(res.data){
                        this.acceptPrivacyAgreementDialogVisible = false;
                        this.acceptPrivacyAgreementRequired = false;
                        sessionStorage.setItem('acceptPrivacyAgreementRequired',this.acceptPrivacyAgreementRequired);
						tools.success(this,'同意协议成功');
                        if(!this.verifyEmailRequired){
                             this.$router.push('/currentAlarm');
                        }
                        else{
                            this.verifyEmailDialogVisible = true;
                        }
					}
                    else{
                        tools.error(this,'同意协议失败');
                    }
				}).catch(function (e) {
                    this.acceptPrivacyAgreementButtonDisabled = false;
                    tools.error(new Vue(),e.message);
				});
                this.listLoading = false;
            },
            cancelVerifyEmailDialog(){
                this.verifyEmailDialogVisible = false;
            },
            verifyEmailOnSubmit(){
                this.$refs.verifyEmailForm.validate((valid) => {
					if (valid) {
						this.verifyEmailButtonDisabled=true;
						let param = {};
                        param.verificationCode = this.verifyEmailForm.verifyCode;
						this.listLoading = true;
						let self = this;
						api.acquireData_verifyEmail_request(param).then((res) => {
							this.verifyEmailButtonDisabled=false;
							this.listLoading = false;
                            this.$refs.verifyEmailForm.resetFields();
                            if(res.data.result){
                                this.verifyEmailDialogVisible = false;
                                this.verifyEmailRequired = false;
                                sessionStorage.setItem('verifyEmailRequired', this.verifyEmailRequired);
                                tools.success(this,"验证成功");
                                this.$router.push('/currentAlarm');
                            }
                            else{
                                tools.error(this,'验证失败');
                            }
							
						}).catch(function (e) {
							tools.error(new Vue(),e.message);
							self.verifyEmailDialogVisible=false;
                            this.verifyEmailButtonDisabled=false;
						});
						this.listLoading = false;
					}
				})
            },
            getEmailVerificationCode(){
                let param = {};
                api.acquireData_getEmailVerificationCode_request(param).then((res) => {
                   tools.success(this,"邮箱校验邮件已发送至您的邮箱");
                }).catch(function (e) {
                    tools.error(new Vue(),e.message);
                });
            }
        },
        mounted(){
            this.createCode();
        }
    }

</script>

<style scoped lang="scss">
    @import '~scss_vars';
        .container {
            min-width: 1190px;
            height:100%;
            margin:0 auto;
            background-image: url("~img/login_bg.png");
            background-position: top center;
            background-size:100% auto;
            .nav_bar{
                border-bottom:0;
                padding: 20px 45px 20px 45px;
                background: rgba(0, 0, 0, 0.6);
            }
            .system_name{
                    width: 1190px;
                    margin: 0 auto;
                img{
                    padding-top: 75px;
                    padding-left: 720px;
                }
            }
            .login_div{
                width: 1190px;
                margin: 0 auto;
                .login_form{
                    padding-top:50px;
                    padding-left:760px;
                    width:360px;
                    height:364px;
                    overflow:hidden;
                    .submit_login_button{
                        margin-left:28%;
                        width:70%;
                        background:#c10c04;
                        border-bottom:1px solid #fff;
                        border-color:#fff
                    }
                    .submit_common_button{
                        display: inline-block;
                        margin-top:2%;
                        margin-left:28%;
                        width:26%;
                        background:#c10c04;
                        border-bottom:1px solid #fff;
                        border-color:#fff
                    }
                }
            }
            .verificationCode{
                height:35px;
                width: 86px;
                border-radius: 4px;
                /*font-size: 18px;*/
                letter-spacing:3px;
                color: #E30613;
            }
            .agreement-describe{
                background:#f3f3f3;
                padding-right:10%;
                padding-bottom: 2px;
                 padding-top: 2px;
                color: #9195a3;
                text-align: right;
           }
        }
        .login_div .el-form-item__label{
            color:#fff;
        }
</style>


// WEBPACK FOOTER //
// login.vue?1c6a38b5